// extracted by mini-css-extract-plugin
module.exports = {"comp":"GoodsA1_comp___5zko"};